/**
 * Schedules and positions PLP promotion banners.
 *
 * Banners arrive from Liquid unplaced at the end of the grid and invisible. This
 * decides which are inside their schedule window and inserts only those, so a
 * tile that has expired or has not started yet occupies no position at all.
 *
 * Placement has to happen here rather than in Liquid: the grid slot a banner
 * lands in depends on which other banners are currently live, and a page
 * rendered before a window opens can still be served from cache after it. A
 * position baked in at render time is a position that goes stale — which is how
 * an expired tile ended up reserving its slot and pushing live tiles one cell
 * early.
 *
 * Every placement is recomputed from scratch on each run, so a tile becoming
 * active, expiring, being disabled or being removed all re-flow the grid with no
 * manual cleanup. Runs on load, at each schedule boundary, and whenever the grid
 * itself changes.
 */
(function () {
  var MAX_DELAY = 86400000; // setTimeout delays are 32-bit; clamp far-future edges.
  var GRID = '.collection-listing__items';
  var BANNER = '[data-slot-position]';
  var PLACED = 'plp-banner--placed';
  var timer = null;

  function parseDate(value) {
    if (!value) return null;
    var t = new Date(value).getTime();
    // An unparseable date must not hide a banner forever.
    return isNaN(t) ? null : t;
  }

  function isActive(banner, now) {
    var start = parseDate(banner.getAttribute('data-banner-start'));
    var end = parseDate(banner.getAttribute('data-banner-end'));
    if (start !== null && now < start) return false;
    if (end !== null && now >= end) return false;
    return true;
  }

  /** The first slot number this page represents, so page 2+ place correctly. */
  function pageOffset(grid) {
    var meta = grid.closest('[collection-items-wrapper]');
    meta = meta && meta.querySelector('[collection-grid-meta]');
    var offset = meta && parseInt(meta.getAttribute('data-current-offset'), 10);
    return offset > 0 ? offset : 0;
  }

  /** Cards per page; a slot past it belongs to the next page. */
  function pageSize(grid) {
    var meta = grid.closest('[collection-items-wrapper]');
    meta = meta && meta.querySelector('[collection-grid-meta]');
    var size = meta && parseInt(meta.getAttribute('data-page-size'), 10);
    return size > 0 ? size : Infinity;
  }

  function place(grid) {
    var banners = Array.prototype.slice.call(grid.querySelectorAll(BANNER));
    if (!banners.length) return Infinity;

    var now = Date.now();
    var offset = pageOffset(grid);
    var size = pageSize(grid);
    var nextEdge = Infinity;
    var live = [];

    banners.forEach(function (banner) {
      // Park every banner at the end and hide it, so each run starts from the
      // same state and positions are derived only from what is live right now.
      banner.classList.remove(PLACED);
      grid.appendChild(banner);

      var start = parseDate(banner.getAttribute('data-banner-start'));
      var end = parseDate(banner.getAttribute('data-banner-end'));
      if (start !== null && start > now && start < nextEdge) nextEdge = start;
      if (end !== null && end > now && end < nextEdge) nextEdge = end;

      if (isActive(banner, now)) live.push(banner);
    });

    live
      .map(function (banner) {
        return { banner: banner, position: parseInt(banner.getAttribute('data-slot-position'), 10) };
      })
      .filter(function (entry) {
        return entry.position > offset && entry.position <= offset + size;
      })
      .sort(function (a, b) {
        return a.position - b.position;
      })
      .forEach(function (entry) {
        // Count only what a customer can actually see: products, the featured
        // tile, and banners already placed by this pass.
        var nextPageTile = grid.querySelector('.collection-listing__item--next-page');
        var slots = Array.prototype.filter.call(grid.children, function (el) {
          return el !== nextPageTile && (!el.hasAttribute('data-slot-position') || el.classList.contains(PLACED));
        });

        var index = entry.position - offset - 1;
        // A position past the end of this page belongs to a later one. Leaving
        // it unplaced is truthful; clamping would invent a slot it never had.
        if (index > slots.length) return;

        entry.banner.classList.add(PLACED);
        grid.insertBefore(entry.banner, slots[index] || nextPageTile);
      });

    return nextEdge;
  }

  function evaluate() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }

    var nextEdge = Infinity;
    Array.prototype.forEach.call(document.querySelectorAll(GRID), function (grid) {
      nextEdge = Math.min(nextEdge, place(grid));
    });

    if (nextEdge < Infinity) {
      // Re-flow the moment a window opens or closes, without a reload.
      timer = setTimeout(evaluate, Math.min(nextEdge - Date.now() + 1000, MAX_DELAY));
    }
  }

  // The fill script and the filtering script both rewrite the grid; either
  // changes what slot a given position refers to.
  document.addEventListener('collection-grid:updated', evaluate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', evaluate);
  } else {
    evaluate();
  }
})();
